import { render } from "./MainLayout.html?vue&type=template&id=4f86a02e&scoped=true&ts=true&external"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import "./MainLayout.scss?vue&type=style&index=0&id=4f86a02e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f86a02e"]])

export default __exports__